import {http} from "@/plugins/axios"
import Excerto from "@/model/excerto"
function buscarExcerto(id) {

    return http
        .get(`excertos/${id}`)
        .then(res => Excerto(res.data))
        .catch((e) => {
            console.log(e);
        });
}

function buscarExcertoFiltro(filtro) {
    return http
        .get("excertos/filtro", {
            params: {
                livrePesquisa: filtro.livrePesquisa,
                subtema: filtro.subtema,
                numeroProcesso: filtro.numeroProcesso,
                ano: filtro.ano,
                exercicioFinanceiro: filtro.exercicioFinanceiro,
                gestor: filtro.gestor,
                relator: filtro.relator
            }
        })
        .then(res => res.data || [])
        .catch((e) => {
            console.error(e);
            throw e; // a tela decide o que mostrar (aviso de indisponibilidade)
        });
}

function buscarTema(id) {
    return http
        .get(`temas/${id}`)
        .then(res => res.data)
        .catch((e) => {
            console.log(e);
            return { temaId: null, nome: "" }
        });
}

function buscarProcesso(numeroProcesso, anoProcesso) {
    return http
    .get("processos/filtro", {
        params: {
            cdProcesso: numeroProcesso,
            anoProcesso: anoProcesso,
        }
    })
    .then(res => res.data)
    .catch((e) => {
        console.log(e);
    });
}

function buscarDeliberacoes(processoId) {
    return http
        .get(`deliberacoes/processo/${processoId}`)
        .then(res => res.data)
        .catch((e) => {
            console.log(e);
        });
}

function buscarDeliberacao(id) {
    return http
        .get(`deliberacoes/${id}`)
        .then(res => res.data)
        .catch((e) => {
            console.log(e);
        });
}

function findAllTemas() {
    return http
        .get("/temas")
        .then((response) => response.data)
        .catch((e) => {
            console.log(e);
        });
}

function salvar(excerto) {
    if (excerto.excertoId == null) {
        
        return http
            .post("excertos/", excerto)
            .then((response) => response.data)
            .catch(err => console.error(err.message));
    } else {
        return http
            .put(`excertos/${excerto.excertoId}`, excerto)
            .then(response => response.data)
            .catch(err => console.error(err.message));
    }

}

function excluir(id){
    return http
        .delete(`/excertos/${id}`)
        .then(res => {
            if(res.status === 204){
                alert("Registro excluído com sucesso.")
                return "ok"
            }
        })
        .catch((e) => {
            console.log(e);
            alert("Erro na solicitação.")
            return "erro"
        });
}

let service = {}

service.buscarExcertoFiltro = buscarExcertoFiltro
service.buscarExcerto = buscarExcerto
service.buscarDeliberacoes = buscarDeliberacoes
service.buscarDeliberacao = buscarDeliberacao
service.buscarProcesso = buscarProcesso

service.salvar = salvar
service.excluir = excluir
service.findAllTemas = findAllTemas
service.buscarTema = buscarTema

export default service
//}